import { useMemo, useCallback } from 'react'
import { useDebounce } from 'react-use'
import { useHistory, useLocation } from 'react-router-dom'
import { useModal } from 'vvs-uikit'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useRedeemGachaMutation } from 'vvs-gotchi-graphql'
import useGachapon from 'state/vvsgotchi/hooks/useGachapon'
import { getUrlSearch, formatUrlSearch } from 'utils/urlSearch'
import { Search } from 'config/constants/paths'
import * as ga from 'utils/googleAnalyticsHelper'

import { gachaponOptionToGraphql, GachaponOption } from './types'
import GachaponModal from './Modal'

const Gachapon: React.FC = () => {
  const { search } = useLocation()
  const gachaponUrlSearch = useMemo(() => getUrlSearch(search, Search.VVS_GOTCHI_GACHAPON[0]), [search])
  const { account } = useActiveWeb3React()
  const gachapon = useGachapon()
  const [redeemGachaponMutate] = useRedeemGachaMutation()
  const history = useHistory()

  const redeemGachapon = useCallback(
    async (option: GachaponOption): Promise<number> => {
      const { data, errors } = await redeemGachaponMutate({
        variables: {
          address: account,
          type: gachaponOptionToGraphql(option),
        },
      })

      if (errors) throw errors
      if (!data.redeemGacha.hasRedeemGacha) throw new Error('hasRedeemGacha is false')

      switch (option) {
        case 'hp':
          return data.redeemGacha.hp
        case 'exp':
          return data.redeemGacha.exp
        default:
          throw new Error('unknown redeem option')
      }
    },
    [account, redeemGachaponMutate],
  )

  const [openModal, closeModal, isModalOpen] = useModal(
    <GachaponModal gachapon={gachapon} history={history} redeemGachapon={redeemGachapon} />,
    true,
    true,
    'vvsgotchiGachapon',
    () => {
      history.replace({
        search: formatUrlSearch([Search.VVS_GOTCHI_GACHAPON[0], null]),
      })
    },
  )

  useDebounce(
    () => {
      const shouldModalOpen = typeof gachaponUrlSearch === 'string'
      if (shouldModalOpen === isModalOpen) return

      if (shouldModalOpen) {
        openModal()

        ga.gotchiOpenGachaponModal()
      } else {
        closeModal()
      }
    },
    60,
    [gachaponUrlSearch, isModalOpen, openModal, closeModal],
  )

  return null
}

export default Gachapon
